import React from 'react'

interface EditIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const EditIcon: React.FC<EditIconProps> = ({
  color = '#000',
  gradient = false,
  width = 23,
  height = 24,
  alt = 'Edit icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 23 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        stroke={gradient ? 'url(#grad1)' : color}
        strokeLinejoin='round'
        strokeWidth='1.25'
        d='M4.373 23.375H.625v-4.136l13.08-14.08 3.782 4.075-13.113 14.14z'
      ></path>
      <path
        stroke={gradient ? 'url(#grad1)' : color}
        strokeWidth='1.25'
        d='M21.458 3.922h0l.005.005c.259.272.267.752.004 1.044l-1.801 1.94-3.794-4.087L17.74.812a.557.557 0 01.834 0l2.885 3.11z'
      ></path>
    </svg>
  )
}

export default EditIcon
